import { ProductIdentifier } from '../../product';

export interface CancelSubscriptionParameters {
  productIdentifier: ProductIdentifier;
  contractId: string;
  endOfPeriod: string;
  terminationDate: string;
}
